// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-success {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.auth-success-container {
  background: white;
  border-radius: 16px;
  padding: 48px 32px;
  text-align: center;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.success-icon {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.success-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 16px;
}

.success-message {
  margin-bottom: 24px;
}

.success-message p {
  font-size: 16px;
  color: #6b7280;
  line-height: 1.6;
}

.tenant-info {
  font-weight: 600;
  color: #4f46e5;
}

.sync-message {
  font-size: 14px;
  color: #9ca3af;
  margin-bottom: 32px;
  font-style: italic;
}

.action-buttons {
  margin-bottom: 24px;
}

.connect-next-btn,
.continue-btn {
  background: #4f46e5;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 200px;
}

.connect-next-btn:hover,
.continue-btn:hover {
  background: #4338ca;
  transform: translateY(-1px);
}

.auto-redirect {
  border-top: 1px solid #e5e7eb;
  padding-top: 24px;
}

.auto-redirect p {
  font-size: 14px;
  color: #9ca3af;
  margin-bottom: 12px;
}

.back-btn {
  background: transparent;
  color: #6b7280;
  border: 1px solid #d1d5db;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

@media (max-width: 640px) {
  .auth-success-container {
    padding: 32px 24px;
  }

  .success-title {
    font-size: 24px;
  }

  .connect-next-btn,
  .continue-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/AuthSuccess.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".auth-success {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 20px;\n}\n\n.auth-success-container {\n  background: white;\n  border-radius: 16px;\n  padding: 48px 32px;\n  text-align: center;\n  max-width: 500px;\n  width: 100%;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.success-icon {\n  margin-bottom: 24px;\n  display: flex;\n  justify-content: center;\n}\n\n.success-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 16px;\n}\n\n.success-message {\n  margin-bottom: 24px;\n}\n\n.success-message p {\n  font-size: 16px;\n  color: #6b7280;\n  line-height: 1.6;\n}\n\n.tenant-info {\n  font-weight: 600;\n  color: #4f46e5;\n}\n\n.sync-message {\n  font-size: 14px;\n  color: #9ca3af;\n  margin-bottom: 32px;\n  font-style: italic;\n}\n\n.action-buttons {\n  margin-bottom: 24px;\n}\n\n.connect-next-btn,\n.continue-btn {\n  background: #4f46e5;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 200px;\n}\n\n.connect-next-btn:hover,\n.continue-btn:hover {\n  background: #4338ca;\n  transform: translateY(-1px);\n}\n\n.auto-redirect {\n  border-top: 1px solid #e5e7eb;\n  padding-top: 24px;\n}\n\n.auto-redirect p {\n  font-size: 14px;\n  color: #9ca3af;\n  margin-bottom: 12px;\n}\n\n.back-btn {\n  background: transparent;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.back-btn:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n@media (max-width: 640px) {\n  .auth-success-container {\n    padding: 32px 24px;\n  }\n\n  .success-title {\n    font-size: 24px;\n  }\n\n  .connect-next-btn,\n  .continue-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
